module.exports = __webpack_public_path__ + "a081a193f1be1ee48e0eea52e65ccfd2.mp3";